import { Component, OnInit, ViewChild } from '@angular/core';
import { AppConfig } from '../../../../app.config';
import { DashboardService } from '../../../../services/dashboard.service';
import { HelpersService } from '../../../../services/helpers.service';
import { CyclistService } from '../../../../services/cyclist.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { DueForService } from '../../../../enums/due-for-service.enum';
import { ChartOptions, ChartType } from 'chart.js';
import { AddEditUserComponent } from '../../../modals/add-edit-user/add-edit-user.component';
import { ScheduleServiceComponent } from '../../../modals/schedule-service/schedule-service.component';
import { Chart } from 'chart.js';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { UpdateJobcardComponent } from '../../../modals/update-jobcard/update-jobcard.component';
import { ServiceRequestService } from '../../../../services/servicerequest.service';
import { PartnerService } from '../../../../services/partner.service';
import { NewJobcardService } from '../../../../services/new-jobcard.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [MessageService],
})
export class DashboardComponent implements OnInit {
  @ViewChild('jobCardsTable') jobCardsTable: any;

  public loading = false;
  public loadingCyclistsRides = true;
  public loadingTechnicians = true;
  public partnerID: string = '';
  public dashboardInfo: any = [];
  public statusList: any = [];
  public dueVal: number = 0;
  public dueScore: number = 0;
  public distanceMetric = 'Km';
  public topTechnicians: any = [];
  public lastestRatings: any = [];
  public linkedCyclistsValue = 0;
  public servicesDueSummary: any = {
    NoBikes: 0,
    DueByHour: 0,
    DueByKM: 0,
    DueByDate: 0,
  };
  public ratingSummary: any = { AvgRating: 0 };
  public linkedCyclists: any = [];
  public linkedCyclistsServicesCompleted: any = [];
  public linkedCyclistStats: any = [];
  public whatsNew: any = [];
  public dailyWorkshopSummary = null;
  public dailyWorkshopDate = moment().add(-1, 'days').format('YYYY-MM-DD');
  public today = moment().format('YYYY-MM-DD');

  public columns: any = [];
  public openColumns: any = [];
  public jobCards: any = [];
  public jobCardsFiltered: any = [];
  public jobCardsListIDOne: any = [];
  public jobCardsListIDTwo: any = [];
  public jobCardsListIDThree: any = [];
  public jobCardsListIDFour: any = [];
  public jobCardsListIDFive: any = [];
  public loadingSLA = false;
  public first = 0;
  public selectedTab = 3;

  public servicesHistory: any = {
    data: [{ data: [], label: '' }],
    labels: [],
    colours: [
      {
        backgroundColor: '#EE3158',
        borderColor: '#EE3158',
      },
    ],
  };

  public chartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    barRoundness: 0.6,
    scales: {
      xAxes: [
        {
          maxBarThickness: 20,
          minBarLength: 2,
          gridLines: {
            color: 'transparent',
          },
          ticks: {
            fontFamily: 'Source Sans Pro',
            fontColor: '#898FA1',
            fontSize: 12,
          },
        },
      ],
      yAxes: [
        {
          stacked: false,
          gridLines: {
            color: 'rgba(35,35,35,0.1)',
          },
          ticks: {
            fontFamily: 'Source Sans Pro',
            fontSize: 12,
            fontColor: '#898FA1',
            beginAtZero: true,
          },
        },
      ],
    },
  };

  public services: number = 0;
  public BASED_ON_HOURS = DueForService.BASED_ON_HOURS;
  public BASED_ON_KILOMETERS = DueForService.BASED_ON_KILOMETERS;
  public BASED_ON_LAST_SERVICE_DATE = DueForService.BASED_ON_LAST_SERVICE_DATE;
  public BASED_ON_MONTH_INTERVAL = DueForService.BASED_ON_MONTH_INTERVAL;

  constructor(
    public dashboardService: DashboardService,
    public helpersService: HelpersService,
    public messageService: MessageService,
    public cyclistService: CyclistService,
    public appConfig: AppConfig,
    public modalService: NgbModal,
    private translate: TranslateService,
    public serviceRequest: ServiceRequestService,
    public partnerRequest: PartnerService,
    public newJobcardService: NewJobcardService,
  ) {
    this.distanceMetric = this.helpersService.getDistanceMetric();
  }

  ngOnInit() {
    this.loading = true;
    this.partnerID = this.helpersService.getPartnerId();
    this.statusList = this.appConfig.getStatusList();
    this.generateColumnHeaders();
    this.loadData();
  }

  ngAfterViewInit() {
    this.RoundedBarChart();
    this.getDashboardInfo();
    this.getServicesHistory();
    this.getTopTechnicians();
    this.getLinkedCyclists();
    this.getLatestRatings();
    //this.getServiceDueSummary();
    this.getDailyWorkshopSummary();
  }

  calcDueForServiceScore(val) {
    if (isNaN(val)) {
      val = 100;
    } else {
      var r = 90;
      var c = Math.PI * (r * 2);

      if (val < 0) {
        val = 0;
      }
      if (val > 100) {
        val = 100;
      }

      var pct = (val / 100) * c;
      this.dueVal = val;
      this.dueScore = pct;
    }
  }

  getDailyWorkshopSummary() {
    this.dashboardService
      .getDailyWorkshopSummary(this.partnerID, this.dailyWorkshopDate)
      .subscribe(
        (res) => {
          this.dailyWorkshopSummary = res;
        },
        (err) => {},
      );
  }

  dailyWorkshopSummaryBack() {
    this.dailyWorkshopDate = moment(this.dailyWorkshopDate)
      .add(-1, 'days')
      .format('YYYY-MM-DD');
    this.getDailyWorkshopSummary();
  }

  dailyWorkshopSummaryForward() {
    this.dailyWorkshopDate = moment(this.dailyWorkshopDate)
      .add(1, 'days')
      .format('YYYY-MM-DD');
    this.getDailyWorkshopSummary();
  }

  getDashboardInfo() {
    this.dashboardService
      .getPartnerDashboardInfo(this.partnerID)
      .subscribe((result) => {
        this.dashboardInfo = result;
        this.loading = false;
        this.services = 0;
        for (let i = 0; i < this.statusList.length; i++) {
          this.statusList[i].metric =
            this.dashboardInfo[this.statusList[i].apiPropertyName];
          this.services += this.statusList[i].metric;
        }
      });
  }

  getServiceDueSummary() {
    this.dashboardService
      .getServiceDueSummary(this.partnerID)
      .subscribe((results) => {
        this.servicesDueSummary = results;
        this.calcDueForServiceScore(
          Math.round(
            (this.servicesDueSummary.NoBikes /
              this.dashboardInfo.LinkedBikes_Count) *
              100,
          ),
        );
      });
  }

  getTopTechnicians() {
    this.dashboardService
      .getPartnerDashboardData(
        this.partnerID,
        'TopTechniciansByServicesCompleted',
      )
      .subscribe((result) => {
        this.topTechnicians = result.filter((item, index) => index < 4); //Show top 4 Technitians Max
        this.loadingTechnicians = false;
      });
  }

  getServicesHistory() {
    const secondaryColor = getComputedStyle(document.documentElement).getPropertyValue('--hubtiger-secondary').trim();
    this.dashboardService
      .getPartnerDashboardData(this.partnerID, 'CurrentServiceStatuses')
      .subscribe((result) => {
        this.servicesHistory.labels = result.map((item) => {
          const date = new Date(
            item.Year +
              '-' +
              (item.Month < 10 ? '0' + item.Month : item.Month) +
              '-01',
          );
          const month = date.toLocaleString('en-us', { month: 'long' });
          return month + ' ' + item.Year;
        });
        this.servicesHistory.data = [
          {
            data: result.map((item) => {
              return item.CompletedServices;
            }),
            label: '',
            backgroundColor: secondaryColor,
            borderColor: secondaryColor
          },
        ];
      });
  }

  getLatestRatings() {
    this.dashboardService
      .getPartnerDashboardData(this.partnerID, 'LatestRatings')
      .subscribe((result) => {
        this.lastestRatings = result;
      });
    this.dashboardService
      .getPartnerDashboardData(this.partnerID, 'AverageRating')
      .subscribe((result) => {
        if (result && result.length > 0) {
          this.ratingSummary = result[0];
        }
      });
  }

  getLinkedCyclists() {
    this.dashboardService
      .getPartnerDashboardData(this.partnerID, 'LinkedCyclists')
      .subscribe((result) => {
        this.loadingCyclistsRides = false;
        this.linkedCyclists = result.map((cyclist) => {
          if (this.distanceMetric.toLowerCase() === 'mi') {
            cyclist.Distance = cyclist.Distance / 1.60934;
          }
          return cyclist;
        });
      });
    this.dashboardService
      .getPartnerDashboardData(
        this.partnerID,
        'LinkedCyclistsServicesCompleted',
      )
      .subscribe((result) => {
        this.linkedCyclistsServicesCompleted = result;
      });
    this.dashboardService
      .getPartnerDashboardData(this.partnerID, 'LinkedCyclistsStats')
      .subscribe((result) => {
        this.linkedCyclistStats = result;
        this.getLinkedCyclistsValue();
      });
  }

  scheduleService() {
    const modalRef = this.modalService.open(ScheduleServiceComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.partnerId = this.partnerID;
    modalRef.result.then(
      (result) => {
        this.messageService.add({ life: 5000, detail: result });
      },
      (onrejected) => {},
    );
  }

  drillServiceReport() {}

  editUser(userId) {
    this.cyclistService.getCyclistById(userId).subscribe((user) => {
      const modalRef = this.modalService.open(AddEditUserComponent, {
        size: 'lg',
        backdrop: 'static',
        windowClass: 'user-modal',
      });
      modalRef.componentInstance.partnerId = this.partnerID;
      modalRef.componentInstance.user = user;
      modalRef.componentInstance.cyclistView = true;
      modalRef.result.then(
        (result) => {},
        (onrejected) => {},
      );
    });
  }

  RoundedBarChart() {
    // todo (errors with chart)
    // // draws a rectangle with a rounded top
    // Chart.helpers.drawRoundedTopRectangle = function (
    //   ctx,
    //   x,
    //   y,
    //   width,
    //   height,
    //   radius,
    // ) {
    //   ctx.beginPath();
    //   ctx.moveTo(x + radius, y);
    //   // top right corner
    //   ctx.lineTo(x + width - radius, y);
    //   ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
    //   // bottom right   corner
    //   ctx.lineTo(x + width, y + height - radius);
    //   ctx.quadraticCurveTo(
    //     x + width,
    //     y + height,
    //     x + width - radius,
    //     y + height,
    //   );
    //   // bottom left corner
    //   ctx.lineTo(x + radius, y + height);
    //   ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
    //   // top left
    //   ctx.lineTo(x, y + radius);
    //   ctx.quadraticCurveTo(x, y, x + radius, y);
    //   ctx.closePath();
    // };
    //
    // Chart.elements.RoundedTopRectangle = Chart.elements.Rectangle.extend({
    //   draw: function () {
    //     var ctx = this._chart.ctx;
    //     var vm = this._view;
    //     var left, right, top, bottom, signX, signY, borderSkipped;
    //     var borderWidth = vm.borderWidth;
    //
    //     if (!vm.horizontal) {
    //       // bar
    //       left = vm.x - vm.width / 2;
    //       right = vm.x + vm.width / 2;
    //       top = vm.y;
    //       bottom = vm.base;
    //       signX = 1;
    //       signY = bottom > top ? 1 : -1;
    //       borderSkipped = vm.borderSkipped || 'bottom';
    //     } else {
    //       // horizontal bar
    //       left = vm.base;
    //       right = vm.x;
    //       top = vm.y - vm.height / 2;
    //       bottom = vm.y + vm.height / 2;
    //       signX = right > left ? 1 : -1;
    //       signY = 1;
    //       borderSkipped = vm.borderSkipped || 'left';
    //     }
    //
    //     // Canvas doesn't allow us to stroke inside the width so we can
    //     // adjust the sizes to fit if we're setting a stroke on the line
    //     if (borderWidth) {
    //       // borderWidth shold be less than bar width and bar height.
    //       var barSize = Math.min(
    //         Math.abs(left - right),
    //         Math.abs(top - bottom),
    //       );
    //       borderWidth = borderWidth > barSize ? barSize : borderWidth;
    //       var halfStroke = borderWidth / 2;
    //       // Adjust borderWidth when bar top position is near vm.base(zero).
    //       var borderLeft =
    //         left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
    //       var borderRight =
    //         right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
    //       var borderTop =
    //         top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
    //       var borderBottom =
    //         bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
    //       // not become a vertical line?
    //       if (borderLeft !== borderRight) {
    //         top = borderTop;
    //         bottom = borderBottom;
    //       }
    //       // not become a horizontal line?
    //       if (borderTop !== borderBottom) {
    //         left = borderLeft;
    //         right = borderRight;
    //       }
    //     }
    //
    //     // calculate the bar width and roundess
    //     var barWidth = Math.abs(left - right);
    //     var roundness = this._chart.config.options.barRoundness || 0.5;
    //     var radius = barWidth * roundness * 0.5;
    //
    //     // keep track of the original top of the bar
    //     var prevTop = top;
    //
    //     // move the top down so there is room to draw the rounded top
    //     top = prevTop + radius;
    //     var barRadius = top - prevTop;
    //
    //     ctx.beginPath();
    //     ctx.fillStyle = vm.backgroundColor;
    //     ctx.strokeStyle = vm.borderColor;
    //     ctx.lineWidth = borderWidth;
    //
    //     // draw the rounded top rectangle
    //     Chart.helpers.drawRoundedTopRectangle(
    //       ctx,
    //       left,
    //       top - barRadius + 1,
    //       barWidth,
    //       bottom - prevTop,
    //       barRadius,
    //     );
    //
    //     ctx.fill();
    //     if (borderWidth) {
    //       ctx.stroke();
    //     }
    //
    //     // restore the original top value so tooltips and scales still work
    //     top = prevTop;
    //   },
    // });
    //
    // Chart.defaults.roundedBar = Chart.helpers.clone(Chart.defaults.bar);
    //
    // Chart.controllers.roundedBar = Chart.controllers.bar.extend({
    //   dataElementType: Chart.elements.RoundedTopRectangle,
    // });
  }

  getLinkedCyclistsValue() {
    var val = 0;
    if (this.linkedCyclistStats && this.linkedCyclistStats.length > 0) {
      var tmp = this.linkedCyclistStats.filter((x) => {
        return x.key === 'My Linked Cyclists';
      });
      if (tmp && tmp.length > 0) {
        val = tmp[0].value;
      }
    }
    this.linkedCyclistsValue = val;
  }

  //===========================================
  generateColumnHeaders() {
    this.openColumns = [
      {
        header: this.translate.instant('general.headers.job_card'),
        field: 'JobCardNo',
        type: 'jobcardno',
      },
      {
        header: this.translate.instant('general.headers.cyclist'),
        field: 'CyclistDescription',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.bike'),
        field: 'BikeDescription',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.work_done'),
        field: 'TypeDescription',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.technician'),
        field: 'TechnicianDescription',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.scheduled'),
        field: 'DateCheckedIn',
        type: 'date',
      },
      //{ header: this.translate.instant('general.headers.original_date'), field: "OriginalBookInDate", type: 'date' },
      //{ header: this.translate.instant('general.headers.days_since_original_date'), field: "DaysSinceOriginalDate", type: 'string' },
      //{ header: this.translate.instant('general.headers.status'), field: "StatusDescription", type: 'status' }
    ];

    this.columns = [
      {
        header: this.translate.instant('general.headers.job_card'),
        field: 'JobCardNo',
        type: 'jobcardno',
      },
      {
        header: this.translate.instant('general.headers.cyclist'),
        field: 'CyclistDescription',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.bike'),
        field: 'BikeDescription',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.work_done'),
        field: 'TypeDescription',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.technician'),
        field: 'TechnicianDescription',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.scheduled'),
        field: 'DateCheckedIn',
        type: 'date',
      },
      /*      { header: this.translate.instant('general.headers.status'), field: "StatusDescription", type: 'status' }*/
    ];
  }

  openJobCard(jobcardID) {

    if (this.helpersService.getPartnerData().UseNewJobCard) {
      this.newJobcardService.openManageJobCard(jobcardID, {
        onRefreshEvents: () => { }
      });

      return;
    }

    this.serviceRequest
      .getServiceRequestData(jobcardID)
      .subscribe((jobcard) => {
        const modalRef = this.modalService.open(UpdateJobcardComponent, {
          size: 'lg',
          backdrop: 'static',
          windowClass: 'jobcard-modal',
        });
        modalRef.componentInstance.jobcard = jobcard;
        modalRef.componentInstance.partnerID = this.partnerID;
        modalRef.result.then(
          (result) => {},
          (onrejected) => {
            //this.getDashboardData();
            //this.loadData(this.activeItem.index);
          },
        );
      });
  }

  loadData() {
    this.loading = true;
    this.partnerRequest
      .getPartnerSLAServices(this.partnerID)
      .subscribe((result: any) => {
        this.jobCards = result;
        if (this.jobCards) {
          this.jobCardsListIDOne = this.jobCards.filter(
            (item) => item.ListID == 1,
          );
          this.jobCardsListIDTwo = this.jobCards.filter(
            (item) => item.ListID == 2,
          );
          this.jobCardsListIDThree = this.jobCards.filter(
            (item) => item.ListID == 3,
          );
          this.jobCardsListIDFour = this.jobCards.filter(
            (item) => item.ListID == 4,
          );
          this.jobCardsListIDFive = this.jobCards.filter(
            (item) => item.ListID == 5,
          );
          this.jobCardsFiltered = this.jobCardsListIDThree;
        }
      });
  }

  filterSLAs(listID) {
    console.log(this.jobCardsTable);
    if (this.jobCardsTable != undefined) this.jobCardsTable.first = 0;

    this.selectedTab = listID;
    this.loadingSLA = true;
    this.first = 0;
    this.jobCardsFiltered = [];
    switch (listID) {
      case 1:
        this.jobCardsFiltered = this.jobCardsListIDOne;
        break;
      case 2:
        this.jobCardsFiltered = this.jobCardsListIDTwo;
        break;
      case 3:
        this.jobCardsFiltered = this.jobCardsListIDThree;
        break;
      case 4:
        this.jobCardsFiltered = this.jobCardsListIDFour;
        break;
      case 5:
        this.jobCardsFiltered = this.jobCardsListIDFive;
        break;
      default:
        this.jobCardsFiltered = [];
    }
    //console.log(this.jobCardsFiltered);
    this.loadingSLA = false;
  }
}
